import { Component, OnDestroy, OnInit, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InputComponent } from '../../../../common/components/form-components/input/input';
import { Button } from '../../../../common/components/form-components/button/button';
import { LoginService } from '../../../services/login-service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageModule } from 'primeng/message';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ChangeDetectorRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ApiResponse } from '../../../../common/models/api-response';
import { TranslateService } from '../../../../i18n/translate.service';

@Component({
  selector: 'app-reset-password',
  imports: [CommonModule, ReactiveFormsModule, RouterModule, InputComponent, Button, MessageModule, ToastModule],
  providers: [MessageService],
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.scss',
})
export class ResetPassword implements OnInit, OnDestroy {
  resetForm!: FormGroup;

  isEmailSent: boolean = false;
  loading: boolean = false;
  submitted: boolean = false;
  showLimitWarning: boolean = false;
  private destroy$ = new Subject<void>();
  showSuccessMessage: boolean = false;

  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    readonly i18n: TranslateService
  ) { }

  ngOnInit() {
    const userDetails = this.loginService.loggedInUserDetails;
    // if (!userDetails) {
    //   this.router.navigate(['/login'], { relativeTo: this.route });
    //   return;
    // }

    const email = userDetails?.email || '';
    this.resetForm = this.fb.group({
      email: [email, [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetForm.valid) {
      console.log('Reset password request for:', this.resetForm.value.email);
      this.sendPasswordResetEmail(false);
    } else {
      this.resetForm.markAllAsTouched();
    }
  }

  sendPasswordResetEmail(isResend: boolean) {
    this.loading = true;
    const userDetails = this.loginService.loggedInUserDetails;
    const orgId = userDetails?.organizationIds?.[0]?.id;
    this.loginService.verfiyEmailForResetPassword(this.resetForm.value.email, orgId).pipe(
      takeUntil(this.destroy$)).subscribe({
        next: (response: ApiResponse<any>) => {
          this.ngZone.run(() => {
            console.log("success", response)
            this.loading = false;
            if (response.responseCode == 200 && response.message == 'Success') {
              this.showLimitWarning = false;
              this.isEmailSent = true;
              if (isResend) {
                this.showSuccessMessage = true;
              }
            } else if (response.responseCode == 404 && response.message == 'Email is not valid') {
              this.showLimitWarning = false;
              this.showSuccessMessage = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email is not valid' });
            } else if (response.responseCode == 429 && response.message == 'Too many requests. Please try again after 15 minutes.') {
              this.showSuccessMessage = false;
              this.showLimitWarning = true;
            }
            this.cd.detectChanges();
          });
        },
        error: (error: ApiResponse<any>) => {
          this.ngZone.run(() => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
            this.cd.detectChanges();
          });
        }
      })
  }

  resendEmail() {
    this.sendPasswordResetEmail(true);
    console.log('Resending email to:', this.resetForm.get('email')?.value);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
